import Layout from '../components/3_organism/layout/layout'
import Head from 'next/head'
import ClientOnly from '../components/0_global/clientOnly'
import { PleaseLogin } from '../components/1_atom/loginButton/loginButton'
import { useAtomValue } from 'jotai'
import { UserDataState } from '../global/state/global'
import { capitalize, classNames } from 'functions'
import Link from 'next/link'
import { useRouter } from "next/router";
import Styles from './extras/styles/settings.module.scss'
import { FadeInAnimationHOC } from '../components/1_atom/animations/slideDownAnimation'
import PremiumSettings from "../components/2_molecule/settings/premiumSettings"
import AppearanceSettings from "../components/2_molecule/settings/appearanceSettings"
import CharactersSettings from "../components/2_molecule/settings/charactersSettings"
import ExperimentalSettings from "../components/2_molecule/settings/experimentalSettings"
import GeneralSettings from "../components/2_molecule/settings/generalSettings"
import SignupsSettings from "../components/2_molecule/settings/signupsSettings"
import { CogIcon, KeyIcon, UserCircleIcon, } from '@heroicons/react/outline'
import { eSettingsTabName } from "typings"
import SvgIcon from '../components/1_atom/buttons/svgIcon'

function SettingsContent() {
  const { isReady, query: routerQuery } = useRouter()
  const tab = routerQuery?.show as string

  const navigationTabs: { label: eSettingsTabName, icon: JSX.Element, content: JSX.Element, hide?: boolean }[] = [
    { label: eSettingsTabName.CHARACTERS, icon: <UserCircleIcon height={24} />, content: <CharactersSettings /> },
    { label: eSettingsTabName.GENERAL, icon: <CogIcon height={24} />, content: <GeneralSettings /> },
    { label: eSettingsTabName.APPEARANCE, icon: <KeyIcon height={24} />, content: <AppearanceSettings /> },
    { label: eSettingsTabName.SIGNUPS, icon: <SvgIcon icon='event-confirm' height={24} width={24} />, content: <SignupsSettings /> },
    { label: eSettingsTabName.PREMIUM, icon: <SvgIcon icon='star-rounded' height={24} width={24} />, content: <PremiumSettings />, hide: false },
    { label: eSettingsTabName.EXPERIMENTAL, icon: <SvgIcon icon='potion' height={24} width={24} />, content: <ExperimentalSettings /> },
  ]

  const TabContent = () => {
    const tabObj = navigationTabs.find(o => o.label === tab)
    if(!!tabObj?.content) return tabObj?.content
    return <CharactersSettings />
  }

  const Tabs = () => {
    return (
      <aside className="py-6 lg:py-0 lg:col-span-3">
        <nav className="space-y-1">
          {navigationTabs.filter(item => item?.hide ? false : true).map((item) => {
            const isActive = item.label === tab
            return (
              <Link
                key={item.label}
                href={{
                  pathname: "settings",
                  query: { show: item.label }
                }}
                className={classNames(
                  Styles.navigationTab,
                  isActive
                    ? Styles.isActive + " bg2 text-white-on-dark"
                    : "text-inactive text-gray-500 ",
                  "group rounded px-3 py-2 flex items-center text-sm font-medium"
                )}
                aria-current={isActive ? "page" : undefined}
              >
                {item.icon}
                <span className="truncate ml1" style={{ color: "inherit" }}>
                  {capitalize(item.label)}
                </span>
              </Link>
            )
          })}
        </nav>
      </aside>
    )
  }

  return (
    <FadeInAnimationHOC show={isReady}>
      <div className="h-full bg1">
        <div className="lg:grid lg:grid-cols-12 lg:gap-x-5">
          <Tabs />
          <div className="flex-col gap3 lg:col-span-9">
            <TabContent />
          </div>
        </div>
      </div>
    </FadeInAnimationHOC>
  )
}

export const SettingsTwo = () => {
  const userData = useAtomValue(UserDataState)

  return (
    <Layout maxLayoutWidth="medium">
      <Head>
        <title>Prepi settings</title>
        <link rel="canonical" href="https://prepi.io" />
      </Head>
      <h2 className="page-title mb3">Settings</h2>
      <ClientOnly>
        {userData ? <SettingsContent /> : <PleaseLogin />}
      </ClientOnly>
    </Layout>
  );
}

export default SettingsTwo;